export default "__VITE_ASSET__CKMVeaZf__"